import type { AppSettings } from '@/types/common';
import { mock as errorMock } from '@/constants/error-mock';

type DevSettings = Pick<AppSettings, 'auth'>;

declare global {
  interface Window {
    settings: any;
    auth: object;
  }
}

const settingLocalEnvironment = () => {
  if (import.meta.env.VITE_CM_AUTH_ACCOUNT_ID) {
    const additionalSettings: DevSettings = {
      auth: {
        username: import.meta.env.VITE_CM_AUTH_USERMANE ?? '',
        spa_id: Number(import.meta.env.VITE_CM_AUTH_ACCOUNT_ID) ?? 0,
      },
    };
    DEFAULT_SETTINGS.auth = {
      spa_id: additionalSettings.auth?.spa_id ?? 123456789,
      username: additionalSettings.auth?.username ?? 'Unknown_player',
    };
  }
};

const DEFAULT_SETTINGS: AppSettings = {
  languageCode: 'ru',
  wsauthHost: 'http://lite.lstdev.net/registration/?game=mk',
  glossUrl: 'https://vortex.korabli.su',
  replayMaxSize: 20_971_520, // Maximum size of a replay file in bytes (20MB)
  commonMenuSrc: '//cmfe-lite.lstdev.net/loader.min.js',
  commonMenuDataRegistrationUrl: '//lesta.ru/registration/?game=mk',
  commonRealm: 'lite',
  commonMenuDataBackendUrl: '//cm-lite.lstdev.net',
};

const isMockError = false;
if (isMockError) DEFAULT_SETTINGS.localizationErrorRu = errorMock;

if (import.meta.env.MODE === 'development') settingLocalEnvironment();

export const settings = window.settings
  ? ({ ...DEFAULT_SETTINGS, ...window.settings } as AppSettings)
  : DEFAULT_SETTINGS;

export const LOCALE = 'ru-RU';

export const VORTEX_ACCOUNTS = '/api/accounts/';
export const GLOSS = '/api/graphql/glossary/';
